/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { Channel, TimeUtils, TvAsset } from '@wit/vtv-x-foundation-lib';
import React from 'react';
import translate from 'services/i18n/translate';
import { ImageLoader } from '..';

interface Props {
  event: TvAsset;
  channel?: Channel;
}

export default function TvEventDetails({ event, channel }: Props): JSX.Element {
  const { startDate } = event as TvAsset;

  const nextAiringDateEpoch = startDate && TimeUtils.isAfterNow(startDate) && TimeUtils.toEpoch(startDate);
  const nextAiringLabel = nextAiringDateEpoch
    ? `${event?.startTime || ''} ${TimeUtils.getShortWeekDay(nextAiringDateEpoch)} ${TimeUtils.getDay(
        nextAiringDateEpoch
      )} ${TimeUtils.getShortMonth(nextAiringDateEpoch)}`
    : '-';

  return (
    <>
      <h6 id="ProgrammeInfoDetails_durationTitle" className="margin-top-22">
        {translate['programInfo.metadata.duration']}
      </h6>
      <span id="ProgrammeInfoDetails_duration">
        {event?.durationValue
          ? translate.formatString(translate['date.minutes'], { duration: event?.durationValue }).toString()
          : '-'}
      </span>

      <h6 id="ProgrammeInfoDetails_nextAiringTitle">{translate['programInfo.metadata.nextairing']}</h6>
      <span id="ProgrammeInfoDetails_nextAiring">{nextAiringLabel}</span>

      <h6 id="ProgrammeInfoDetails_channelTitle">{translate['programInfo.metadata.channel']}</h6>
      <ImageLoader
        className="channel-logo"
        src={channel?.logo?.white?.uri || ''}
        fallbackText={channel?.title || '-'}
        fallbackClass={channel?.title ? 'fallback-text' : ''}
        showFallbackOnLoading
        bemModifier={`eventDetailsLogo-${event.id}`}
      />
    </>
  );
}
